import { createSlice } from '@reduxjs/toolkit';
import { APIStatus } from '@application/enums/api-status';
import { globalSearchAsync } from './globalSearchThunk';
const initialState = {
    status: APIStatus.IDLE
};
export const globalSearchSlice = createSlice({
    name: 'globalSearch',
    initialState,
    reducers: {
        clearResults: (state) => {
            state.results = [];
            state.totalResults = 0;
            state.status = APIStatus.IDLE;
            state.apiError = undefined;
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(globalSearchAsync.pending, (state) => {
            state.status = APIStatus.PENDING;
            state.apiError = undefined;
        })
            .addCase(globalSearchAsync.fulfilled, (state, action) => {
            state.status = APIStatus.SUCCESS;
            const payload = action.payload;
            state.results = payload.results || [];
            state.totalResults = payload.totalResults || 0;
        })
            .addCase(globalSearchAsync.rejected, (state, action) => {
            state.status = APIStatus.FAILED;
            state.apiError = action.payload;
            state.results = [];
            state.totalResults = 0;
        });
    }
});
export const { clearResults } = globalSearchSlice.actions;
export default globalSearchSlice.reducer;
